import React from 'react';
import { ReactComponent as ArrowIcon } from '../assets/chevron_backward_large.svg';

export interface HowThisWorksProps {
  back: () => void;
}

const HowThisWorks: React.FC<HowThisWorksProps> = ({ back }) => {
  return (
    <div className="info-container">
      <button onClick={back} className="small">
        <ArrowIcon /> Back
      </button>

      <h1>How this works</h1>
      <p>This is your live programme.</p>
      <p>
        You will be shown the content relevent to what&apos;s going on,
        there&apos;s nothing you need to do.
      </p>
      <p>
        If you want to go back and see something that you might have missed,
        press the back icon, and you can go back through the previous pages.
        When you&apos;re ready to resume watching the live content, press the
        resume button.
      </p>
      <p>
        Once the event has finished, you can always access this programme to
        revisit the content whenever you want.
      </p>
    </div>
  );
};

export default HowThisWorks;
